export default __webpack_public_path__ + "app/images/theme-images/shared/file/icon-36-file@2x.webp";